<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <mat-icon fontSet="material-symbols-outlined">edit_note</mat-icon>
      </div>
      <div>
        <h2 class="modal-title">Editar relato</h2>
        <p class="modal-subtitle">Altere as informações do relato</p>
      </div>
    </div>
    <button class="btn-close" type="button" (click)="fechar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" for="titulo">
        Título do relato <span class="required">*</span>
      </label>
      <input
        id="titulo"
        type="text"
        [(ngModel)]="titulo"
        class="form-input"
        placeholder="Título do relato"
      />
    </div>

    <div class="form-group">
      <label class="form-label" for="descricao">Descrição do relato</label>
      <textarea
        id="descricao"
        [(ngModel)]="descricao"
        class="form-textarea"
        rows="4"
        maxlength="2000"
        placeholder="Descreva o relato..."
      ></textarea>
      <div class="textarea-footer">
        <span class="char-count">{{ descricao.length }}/2000</span>
      </div>
    </div>

    <div class="form-group form-group-checkbox">
      <label class="checkbox-label">
        <input type="checkbox" [(ngModel)]="enviarEmail" class="checkbox-input" />
        <span>Enviar informações por e-mail</span>
      </label>
    </div>

    <div class="form-group" *ngIf="enviarEmail">
      <label class="form-label">Contatos</label>
      <app-filtro-select-busca
        [multi]="true"
        [options]="contatoOptions"
        [(selectedValues)]="selectedResponsaveis"
        placeholder="Selecione os contatos"
        placeholderBusca="Buscar contato..."
      ></app-filtro-select-busca>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-secondary" type="button" (click)="fechar()">
      Cancelar
    </button>
    <button class="btn-primary" type="button" (click)="editarRelato()">
      <mat-icon>edit</mat-icon>
      Editar relato
    </button>
  </div>
</div>
